import HeroBanner from './HeroBanner.js';
import HeroImageCarousel from './HeroImageCarousel.js';
import HeroVideo from './HeroVideo.js';

const HeroSection = ({ images = [], homepage, video, poster }) => {
  if (!homepage) return null;

  // Video mode: use HeroVideo component
  if (video || (poster && images.length === 0)) {
    return (
      <HeroVideo videoSrc={video} posterSrc={poster || images[0]} images={images}>
        <HeroBanner />
      </HeroVideo>
    );
  }

  // Default: carousel mode
  return (
    <div className="hero relative flex flex-col justify-end overflow-hidden">
      <HeroImageCarousel images={images} />
      <div className="absolute inset-0 bg-black bg-opacity-70"></div>
      <HeroBanner />
    </div>
  );
};

export default HeroSection;
